export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}

export function scrollToTop() {
    if (window.__lenis) {
        window.__lenis.scrollTo(0, { duration: 1.4 });
    } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
}
